import { Routes } from '@angular/router';

export const full: Routes = [
    {
        path: 'principal',
        loadChildren: () => import('../../modules/principal/principal.module').then(m => m.PrincipalModule),
    },
];
